import { TFunction } from 'i18next';
import React from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from 'react-router-dom';
import { ISecondaryProductItemData } from '../../../../business';

interface IAdditionalProducts {
    data: ISecondaryProductItemData[];
    isMobile: boolean;
    translate: TFunction<"product", undefined>;
}

const cardStyle: React.CSSProperties = {
    marginRight: '20px',
    marginBottom: '40px',
    border: '0px',
    borderRadius: '20px',
    paddingTop: '20px',
    paddingBottom: '40px',
    cursor: 'pointer'
};

const cardTitleStyle: React.CSSProperties = {
    fontSize: '15px',
    height: '50px',
    lineHeight: '1.5',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};

const cardImageStyle: React.CSSProperties = {
    width: '9rem',
    mixBlendMode: 'multiply',
    marginTop: '15px'
};

export const AdditionalProducts: React.FC<IAdditionalProducts> = ({ data, isMobile, translate }) => {
    const navigate = useNavigate();
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 6
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const getDeviceType = () => {
        if (window.innerWidth <= 464) return 'mobile';
        if (window.innerWidth <= 1024) return 'tablet';
        return 'desktop';
    };

    const deviceType = getDeviceType();

    const productItem = (productItemData: ISecondaryProductItemData, key: React.Key) => (
        <Card
            style={cardStyle}
            className={deviceType === "mobile" ? "" : "shadow"}
            onClick={() => navigate(`/product/${productItemData.url}`)}
            key={key}
        >
            <Card.Title style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                    src={productItemData.image}
                    alt={productItemData.description}
                    style={cardImageStyle}
                />
            </Card.Title>
            <Card.Body>
                <Card.Title style={cardTitleStyle}>
                    {productItemData.description}
                    <p>
                        <Badge
                            pill
                            bg={productItemData.condition === "PRODUCT_NEW" ? "primary" : "secondary"}
                            className="font-poppins"
                        >
                            {translate(productItemData.condition ? productItemData.condition : "")}
                        </Badge>
                    </p>
                </Card.Title>
                <Card.Text>
                    <b>R$ {productItemData.value}</b>
                </Card.Text>
            </Card.Body>
        </Card>
    )

    return (
        <Row className={`rounded bg-white mb-5 p-4 ${isMobile ? "" : " mt-4 shadow"}`}>
            <Col>
                <h5>{translate('additionalProductsTitle')}</h5>
                <hr />
                <Carousel
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    responsive={responsive}
                    ssr={true}
                    infinite={true}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    deviceType={deviceType}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                >
                    {data.map((product, index) => productItem(product, index))}
                </Carousel>
            </Col>
        </Row>
    );
};